//#region src/js/templates/header.js
function setHeaderHeight(header) {
	if (!header) header = document.querySelector(".moonbase-header");
	const announcementBar = document.querySelector(".moonbase-announcement-bar");
	let headerHeight = header.offsetHeight;
	if (announcementBar && isInViewport(announcementBar)) headerHeight += announcementBar.offsetHeight;
	else headerHeight = header.offsetHeight;
	document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
}
function isInViewport(element) {
	if (!element) return false;
	const rect = element.getBoundingClientRect();
	return rect.bottom > 0 && rect.right > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.left < (window.innerWidth || document.documentElement.clientWidth);
}
var StickyHeader = class extends HTMLElement {
	connectedCallback() {
		this.header = document.querySelector(".moonbase-header");
		this.stickyType = "on-scroll-up";
		this.lastScrollY = window.scrollY;
		this.ticking = false;
		this.scrollThreshold = 50;
		setHeaderHeight(this.header);
		this._onScroll = () => {
			if (!this.ticking) {
				requestAnimationFrame(() => this._handleScroll());
				this.ticking = true;
			}
		};
		this._onResize = () => setHeaderHeight(this.header);
		window.addEventListener("scroll", this._onScroll, { passive: true });
		window.addEventListener("resize", this._onResize, { passive: true });
	}
	disconnectedCallback() {
		window.removeEventListener("scroll", this._onScroll);
		window.removeEventListener("resize", this._onResize);
	}
	_handleScroll() {
		const scrollY = window.scrollY;
		const scrollingDown = scrollY > this.lastScrollY;
		if (this.stickyType === "always") this.header.classList.remove("shopify-section-header-hidden");
		else if (scrollingDown && scrollY > this.scrollThreshold) this.header.classList.add("shopify-section-header-hidden");
		else if (!scrollingDown) this.header.classList.remove("shopify-section-header-hidden");
		this.lastScrollY = scrollY;
		this.ticking = false;
	}
};
if (!customElements.get("custom-header")) customElements.define("custom-header", StickyHeader);
//#endregion
export { setHeaderHeight };
